module.exports = {
  __depends__: [
    require(73),
    require(102),
    require(159),
    require(100),
    require(104),
    require(39)
  ],
  __init__: [ 'contextPadProvider' ],
  contextPadProvider: [ 'type', require(7) ]
};